var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"toucher",staticClass:"full"},[(_vm.toucher)?_c('Engine',{attrs:{"bloom":'default',"toucher":_vm.toucher},on:{"ready":function($event){_vm.engine = $event; _vm.setup()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }